import {
  Box,
  Text,
  Flex,
  Button,
  Stack,
  List,
  ListItem,
  ListIcon,
  Img,
  Center,
  Image,
  Spacer,
  IconButton,
  Skeleton,
  useColorMode
} from "@chakra-ui/react";
import { FiThumbsUp,FiThumbsDown } from "react-icons/fi";
import { BsPlayCircleFill } from "react-icons/bs";
import { Icon, SearchIcon } from "@chakra-ui/icons";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useEffect,useState } from "react";
import { useYoutubeAPI } from "@/src/hooks/useYoutube";

export default function PocItem({id, videoUrl, title, description }) {
  const { t } = useTranslation();
  const router = useRouter();
  const {colorMode}=useColorMode();
  const [viewCount,setViewCount]=useState(0);
  const [previewImage,setPreviewImage]=useState(null);
  const [statistics,setStatistics]=useState({viewCount: '0', likeCount: '0', favoriteCount: '0', commentCount: '0'});
  const {extractYouTubeVideoId,fetchYoutubeThumbnails,fetchVideoStatistics}=useYoutubeAPI();
  useEffect(async () => {
      // thumbnail 
      const videoId=extractYouTubeVideoId(videoUrl);
      fetchYoutubeThumbnails(videoId).then(
        (data)=>{
          setPreviewImage(data);
        }
      ).catch();
      // statistics 
      fetchVideoStatistics(videoId).then(
        (data)=>{
          setStatistics(data);
        }
      ).catch();
  }, []);
  return (<a href={`/pocs/${id}`} className="">
    <Box
      
    //   cursor="pointer"
      mt="40px"
      maxWidth={{ base: "350px", md: "379px" }}
      // width="100%"
      mx={{ base: "10px" }}
      borderWidth="1px"
      borderRadius="10px"
      overflow="hidden"
      shadow="md"
      p="5px"
      bgColor={colorMode === "light" ? "white" : "#023b31"}
      // pb="40px"
      h="auto"
      as={Flex}
      flexDirection={"column"}
    >
      {/* image */}
      <Flex h="192px" position={"relative"} w="full" flex={"column"}>
    {previewImage ? (<Image alt={"eclipse white"} h="full" w="full"  src={previewImage} />) : (<Skeleton  h="full" w="full"   />)}  
        <Box w={"full"} as={Flex} position={"absolute"} alignItems={"center"} justifyContent={"center"}  h="full" bgColor={"transparent"} >
                <IconButton onClick={() => {
        router.push(`/pocs/${id}`);
      }}  aria-label={"cover"} bg={"transparent"} color={"brand.500"}  icon={<BsPlayCircleFill size={40}/>} position={"absolute"}/>
            
        </Box>
      </Flex>
      {/* la date  */}
      <Box p="14px">
        <Text color={colorMode === "light" ? "#232323" : "brand.500"} mb="20px" fontWeight={500} fontSize={"20px"} noOfLines={1}>
          {title}
        </Text>
        <Text
          color={colorMode === "light" ? "#232323" : "white"}
          fontWeight={400}
          fontSize={"16px"}
          textAlign={"left"}
          mb="20px"c
          noOfLines={1}
        >
          {description}
        </Text>
        <Box>
          <Flex alignItems="center" justifyContent="space-between">
            <Text color={"brand.500"} fontWeight={400} fontSize={"14px"}>
              {statistics.viewCount} {t("pocs:views")}
            </Text>
            <Flex alignItems="center" gap={"12px"} justifyContent="end">
              <Button
              variant="unlink"
                colorScheme="transparent"
                bgColor={"transparent"}
              p="0"
                color={"#FF8A60"}
                aria-label="Search database"
                fontWeight={500}
                fontSize={"16px"}
                leftIcon={<FiThumbsUp color={""} />}
                cursor="default"
              >{statistics.likeCount}</Button>
              <Button
              p="0"
                variant="unlink"
                colorScheme="transparent"
                bgColor={"transparent"}
                aria-label="Search database"
                fontSize={"16px"}
                fontWeight={500}
                color={"brand.500"}
                cursor="default"
                leftIcon={<FiThumbsDown  />}
              >
                {statistics.dislikeCount ? statistics.dislikeCount : 0}
              </Button>
            </Flex>
          </Flex>
        </Box>
      </Box>
    </Box>
    </a>
  );
}

//   /images/blog_item.png
